export type ExecutionHistoryAggregateActionTaskState = 'running' | 'finished' | 'error'

export enum ExecutionHistoryAggregateActionState {
  NotStarted = 'not-started',
  Running = 'running',
  Passed = 'passed',
  Stopped = 'stopped',
  Ignored = 'ignored',
  Error = 'error',
}

export type ExecutionHistoryEntryState = 'running' | 'stopped' | 'finished' | 'error'

export enum ConditionTypes {
  SingleChoice = 'single_choice',
  Number = 'number',
  User = 'user',
  Identifier = 'identifier',
  Date = 'date',
  Boolean = 'boolean',
  String = 'string',
}
